import React, { useCallback, useEffect, useState } from "react"
import { ToastContainer, toast } from "react-toastify"
import { useNavigate } from "react-router-dom"
import { request } from "../../services/request"
import { CustomerDetail, Customernterface } from "../../services/authinterface"
import Table, { TableAction } from "../../components/common/Table"
import { useDebounce } from "../../hooks/useDebounce"
import { useDispatch } from "react-redux"
import { changeloaderState } from "../../store/loaderSlice"
import { AppDispatch } from "../../store/store"
import PrimaryButton from "../../components/subComponents/PrimaryButton"
import { donwloadCSV, downloadPDF } from "../../utils/exportFunctions"

const SensorSosSettings: React.FC = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch<AppDispatch>()
  const [sensorSosSettings, setSensorSosSettings] = useState<CustomerDetail[]>([])
  const [page, setPage] = useState(1)
  const [rowsPerPage, setRowsPerPage] = useState(25)
  const [totalItems, setTotalItems] = useState(100)
  const [search, setSearch] = useState("")
  const debounceText = useDebounce(search, 500)
  const [sort, setSort] = useState("DESC")
  const [sortCol, setSortCol] = useState("createdAt")

  const fetchSensorSosSettings = useCallback(async () => {
    try {
      dispatch(changeloaderState(true))
      const params = {
        page: page,
        limit: rowsPerPage,
        search: debounceText,
        sort: sort,
        sortCol: sortCol,
      }
      const response = await request<Customernterface>({
        url: "/adminCustomers/getCustomers",
        method: "POST",
        data: params,
      })

      if (response.success) {
        setSensorSosSettings(response.data)
        setTotalItems(response.total)
      } else {
        toast.error("Failed to fetch customers: " + response.message)
      }
    } catch (error: any) {
      toast.error(`${error?.response?.data?.message ||
        error?.message ||
        "Something went wrong"}`)
    } finally {
      dispatch(changeloaderState(false))
    }
  }, [dispatch, page, rowsPerPage, debounceText, sort, sortCol])

  useEffect(() => {
    fetchSensorSosSettings()
  }, [page, rowsPerPage, debounceText, sort, fetchSensorSosSettings])

  useEffect(() => {
    if (debounceText) {
      setPage(1) // Reset to first page on search
    }
  }, [debounceText])

  const columns = [
    {
        name: "Email",
        value: (sensor: CustomerDetail) => sensor.email,
        id: "email",
    },
  ]
  const action: TableAction[] = [
    {
      label: "Edit",
      isRedirect: true,
      link: (row: CustomerDetail) => `/sensor-sos-settings/edit/${row.id}`,
      className: "table-btn-1",
    },
  ]

  const fetchAllSensorSosSettings = async () => {
    try {
      const params = {
        page: 1,
        search: debounceText,
        limit: 100000,
        sort: sort,
        sortCol: sortCol,
      };
      const response = await request<Customernterface>({
        url: "/adminCustomers/getCustomers",
        method: "POST",
        data: params,
      });
      if (response.success) {
        return response.data;
      } else {
        toast.error("Failed to fetch all Sensor SOS Settings: " + response.message);
        return [];
      }
    } catch (error: any) {
      toast.error(`Error fetching all Sensor SOS Settings: ${error?.response?.data?.message ||
        error?.message ||
        "Something went wrong"}`);
      return [];
    }
  };

  const addAction = 
      {
        label: "+ Add",
        type: "button",
        className: "",
        onClick: () => {
            navigate("/sensor-sos-settings/add")
        },
      }

  const exportCSV = async () => {
    const allData = await fetchAllSensorSosSettings();
    if (!allData.length) {
      toast.error("No data available to export.");
      return;
    }
    const headers = [
      "Sr No.",
      "Email",
    ];
    const rows = allData.map((s, index) => [
      index + 1,
      s.email,
      s.status === "1" ? "Active" : "Inactive",
    ])
    donwloadCSV(headers, rows, "Sensor-SOS-Settings.csv");
  };

  const exportPDF = async () => {
    const allData = await fetchAllSensorSosSettings();
    if (!allData.length) {
      toast.error("No data available to export.");
      return;
    }
    const headers = [
      "Sr No.",
      "Email",
    ];
    const rows = allData.map((s, index) => [
      index + 1,
      s.email,
      s.status === "1" ? "Active" : "Inactive",
    ])
    downloadPDF(headers, rows, "Sensor-SOS-Settings");
  };
  return (
    <section className=' dashboard-section dashboard-item '>
      <ToastContainer position='top-right' autoClose={2000} theme='light' />

      <div className='container'>
        <div className='row'>
          <div className='col-12'>
            <div className='dashboard-table-title-section'>
              <h2>Sensor SOS Settings</h2>
              <div className='dashboard-table-title-right-side d-flex gap-2'>
                <PrimaryButton
                  label='Export CSV'
                  className='max-w-max-content'
                  onClick={exportCSV}
                />
                <PrimaryButton
                  label='Export PDF'
                  className='max-w-max-content'
                  onClick={exportPDF}
                />
              </div>
            </div>
          </div>
          <div className='col-12 mt-4'>
            <div className='table-container-main'>
              {/* <div className='table-details-section'></div> */}
              <Table
                rowData={sensorSosSettings}
                columns={columns}
                page={page}
                setPage={setPage}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
                totalItems={totalItems}
                setSortColumn={setSortCol}
                setSortOrder={setSort}
                sortColumn={sortCol}
                sortOrder={sort}
                action={action}
                isSearch
                search={search}
                setSearch={setSearch}
                addAction={addAction}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default SensorSosSettings
